import Work1 from "../../assets/work-1.svg";
import Work2 from "../../assets/work-2.svg";
import Work3 from "../../assets/work-3.svg";
import Work4 from "../../assets/work-4.svg";
import Work5 from "../../assets/work-5.svg";
import Work6 from "../../assets/work-6.svg";
import Work7 from "../../assets/work-7.svg";

const Menu = [
    {
      id: 1,
      image: Work1,
      title: "S.O.Odingo & Co. Advocates Website",
      category: "Design",
      link:"http://soodingoadvocates.co.ke/",
    },
    {
      id: 2,
      image: Work7,
      title: "Watama Advocates Website",
      category: "Art",
      link:"https://watamalawadvocates.co.ke/",
    },
    {
      id: 3,
      image: Work3,
      title: "Delivery App Wireframe",
      category: "Branding",
      link:"https://watamalawadvocates.co.ke/",
    },
    {
      id: 4,
      image: Work4,
      title: "Onboarding Motivation",
      category: "Design",
      link:"https://watamalawadvocates.co.ke/",
    },
    {
      id: 5,
      image: Work5,
      title: "iMac Mockup Design",
      category: "Creative",
      link:"https://watamalawadvocates.co.ke/",
    },
    {
      id: 6,
      image: Work6,
      title: "Game Store App Concept",
      category: "Art",
      link:"https://watamalawadvocates.co.ke/",
    },
  ];
  

export default Menu